import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    question: "How long does caulking typically last?",
    answer: "Quality caulking, when properly applied, can last 15-20 years depending on the location and exposure to moisture. We use premium silicone and acrylic sealants to maximize longevity.",
  },
  {
    question: "Do you remove old caulking before applying new?",
    answer: "Yes, absolutely. Proper preparation is crucial for a long-lasting seal. We always remove all old caulking, clean the surfaces thoroughly, and ensure they're completely dry before applying new sealant. This ensures optimal adhesion and a professional finish.",
  },
  {
    question: "What areas of Adelaide do you service?",
    answer: "We service all of Adelaide and the greater South Australia region, including Adelaide Hills, Glenelg, Norwood, Henley Beach, Port Adelaide, Unley, and surrounding suburbs. Contact us if you're unsure about your area.",
  },
  {
    question: "How much does caulking cost?",
    answer: "Pricing varies based on the scope of work, type of sealant required, and accessibility. We provide free, no-obligation quotes for all jobs. Prices start from $350.",
  },
  {
    question: "Do you offer a warranty on your work?",
    answer: "Yes, we stand behind our work with a 5-year warranty on all caulking services. If any issues arise due to workmanship within this period, we'll return to fix it at no additional cost.",
  },
  {
    question: "How quickly can you complete the job?",
    answer: "Most residential caulking jobs can be completed within a few hours to a full day. We offer same-day service for urgent requests when available. The caulking will need 24-48 hours to fully cure before exposing to water.",
  },
];

const FAQ = () => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <p className="text-sm text-[#525252] tracking-widest mb-4">FAQ</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#0a0a0a]">
            COMMON QUESTIONS
          </h2>
        </motion.div>

        {/* Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-[#e5e5e5] faq-item"
              >
                <AccordionTrigger
                  className="text-left font-heading text-lg font-bold text-[#0a0a0a] hover:no-underline py-6"
                  data-testid={`faq-trigger-${index}`}
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#525252] pb-6 leading-relaxed" data-testid={`faq-content-${index}`}>
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
